<div class="page-section">
    <div class="page-section-header">
        <h2 class="page-section-title">Withdraw ({{status == 2 ? 'Pending Approval' : status == 1 ? 'Approved' : 'Rejected'}})</h2>
    </div>
    <div class="page-section-filters">
        <div class="btn-group btn-group-sm">
            <button class="btn btn-outline-primary text-nowrap" [class.active]="status == 2" (click)="getWithdraws(2)">Pending</button>
            <button class="btn btn-outline-primary text-nowrap" [class.active]="status == 1" (click)="getWithdraws(1)">Approved</button>
            <button class="btn btn-outline-primary text-nowrap" [class.active]="status == 0" (click)="getWithdraws(0)">Rejected</button>
        </div>
        <form class="d-flex flex-wrap gap-2 align-items-end mt-2" (ngSubmit)="getWithdraws()">
            <label>From (MYT)<input type="date" name="date_from" class="form-control form-control-sm" [(ngModel)]="filter.date_from"></label>
            <label>To (MYT)<input type="date" name="date_to" class="form-control form-control-sm" [(ngModel)]="filter.date_to"></label>
            <label>Player / bank account<input name="search" class="form-control form-control-sm" [(ngModel)]="filter.search" placeholder="Player code, name or full account"></label>
            <button class="btn btn-primary btn-sm" [disabled]="is_loading">Apply</button>
            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="clearFilters()" [disabled]="is_loading">Clear</button>
        </form>
    </div>
    <div class="alert alert-danger" role="alert" *ngIf="error">{{error}}</div>
    <div class="page-section-body">
        <table class="table">
            <thead>
                <tr>
                    <th>No</th>
                    <th>Player</th>
                    <th>Player Name</th>
                    <th>Amount</th>
                    <th>Bank</th>
                    <th>Bank Account</th>
                    <th *ngIf="status == 2">Status</th>
                    <th *ngIf="status == 2">Bank</th>
                    <th *ngIf="status == 2">Action</th>
                    <th>Date</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let withdraw of withdraws; let i = index">
                    <td>{{i+1}}</td>
                    <td>{{withdraw.player_code}} <span *ngIf="withdraw.is_suspended == 1" class="badge bg-danger">Suspended</span></td>
                    <td>
                        <input type="text" class="form-control form-control-sm" [(ngModel)]="withdraw.fullname" *ngIf="status == 2">
                        <span *ngIf="status != 2">{{withdraw.fullname}}</span>
                    </td>
                    <td>
                        <ng-container *ngIf="status == 2 && allow_edit_balance">
                            <div class="input-group input-group-sm flex-nowrap" style="min-width: 170px;">
                                <input type="number" step="0.01" min="0" [max]="withdraw.max_amount" class="form-control form-control-sm" [(ngModel)]="withdraw.amount" (blur)="clampAmount(withdraw)">
                                <button type="button" class="btn btn-outline-secondary" (click)="trimAmount(withdraw)" title="Trim down to the nearest lower {{trim_step}} (strictly below the current amount)">.00</button>
                            </div>
                            <small class="text-muted">Max: {{withdraw.max_amount | number: '1.2-2'}}</small>
                        </ng-container>
                        <span *ngIf="!(status == 2 && allow_edit_balance)">{{withdraw.amount | number: '1.2-2'}}</span>
                    </td>
                    <td>{{withdraw.bank_name}}</td>
                    <td>{{withdraw.bank_account}}</td>
                    <td *ngIf="status == 2">
                        <select class="form-select form-select-sm" [(ngModel)]="withdraw.status">
                            <option [value]="1" selected>Approved</option>
                            <option [value]="0">Rejected</option>
                        </select>
                    </td>
                    <td *ngIf="status == 2">
                        <ng-container *ngIf="withdraw.status == 1">
                            <select class="form-select form-select-sm" [(ngModel)]="withdraw.bank_id" (change)="changeBank(withdraw)">
                                <option *ngFor="let bank of banks" [value]="bank.id">{{bank.title}} - {{bank.payee}} - {{bank.account}} {{bank.auto ? '(Auto)' : '(Manual)'}}</option>
                            </select>
                            <div class="mt-3" *ngIf="withdraw.bank_id">
                                <label for="file" class="form-label">Upload Proof</label>
                                <input type="file" id="file" accept="image/*" class="form-control form-control-sm" (change)="uploadFile($event, withdraw)">
                                <img src="{{withdraw.file}}" class="img-fluid" *ngIf="withdraw.file">
                            </div>
                        </ng-container>
                    </td>
                    <td *ngIf="status == 2">
                        <button class="btn btn-primary btn-sm" [disabled]="withdraw._submitting || withdraw.is_suspended == 1" (click)="updateWithdraw(withdraw)">{{ withdraw._submitting ? 'PROCESSING...' : 'UPDATE' }}</button>
                    </td>
                    <td>{{withdraw.create_on | date:'dd/MM/yyyy HH:mm'}}</td>
                </tr>
                <tr *ngIf="withdraws.length == 0 && !is_loading">
                    <td colspan="100%" class="text-center text-muted py-4" style="font-style: italic;">No data found</td>
                </tr>
                <tr *ngIf="is_loading">
                    <td colspan="100%" class="text-center text-muted py-4" style="font-style: italic;">Loading...</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="page-section-footer" *ngIf="!is_loading && withdraws.length > 0">
        <span>Total Withdrawals:</span>
        <span class="page-section-stat">{{withdraws.length}}</span>
    </div>
</div>
